'use strict'

const maybe = require('folktale/maybe')

const dataBindingFilterResolver = dependenciesMap => ({ filterId }) =>
  maybe
    .fromNullable(dependenciesMap[filterId])
    .chain(({ controllerApi, fieldName }) =>
      maybe
        .fromNullable(controllerApi.getCurrentItem())
        .map(item => item[fieldName])
    )

module.exports = dataBindingFilterResolver



// WEBPACK FOOTER //
// ./filter-resolvers/databinding.js